import SalarieNumero from '@/generated/controls/salarie/SalarieNumero.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SalarieNumero
})
